import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=6bfd8074&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=6bfd8074&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd8074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfd8074')) {
      api.createRecord('6bfd8074', component.options)
    } else {
      api.reload('6bfd8074', component.options)
    }
    module.hot.accept("./MessagesList.vue?vue&type=template&id=6bfd8074&scoped=true", function () {
      api.rerender('6bfd8074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lists/MessagesList.vue"
export default component.exports